import React, { Component } from "react";
import {
  Row,
  Col,
  Form,
  Space,
  Button,
  Input,
  Table,
  Tooltip,
  Checkbox,
  message,
} from "antd";
import { Link } from "react-router-dom";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";

import { DeleteFilled } from "@ant-design/icons";
import config from "../config";
import AssignZoneToFairStore from "../store/AssignZoneToFareStore";

class AssignZoneToFair extends Component {
  constructor(props) {
    super(props);

    this.assignZoneStore = new AssignZoneToFairStore(this);

    this.formRef = React.createRef();
    this.state = {
      loading: false,
      loadData: 1,
      searchGeofenceData: [],
      assignedZoneId: [],
      assignZoneArray: [],
      selectedSearchZoneId: [],
    };
  }


  async componentDidMount() {

    await this.assignZoneStore.getGeofenceData(this.props.companyId);

    await this.setState({
      searchGeofenceData: this.assignZoneStore?.geoDataArr,
    });
    await this.assignZoneStore.getSelectedZone({
      companyId: this.props.companyId,
      parameterId: this.props.parameterId,
    });
    const assignedZones = this.assignZoneStore?.selectedZoneArr || [];

    const zoneIds = assignedZones.map(zone => zone.zoneId);
  
    await this.setState({
      assignZoneArray: assignedZones,   // fill assigned zones in 2nd table
      assignedZoneId: zoneIds,          // select correct rows in 1st table
      selectedSearchZoneId: zoneIds,    // keep 2nd table selection synced
    })
    this.columns = [
      {
        title: this.context.translate("_GEOFENCE_"),
        dataIndex: "name",
      },
    ];
    this.assignedColumns = [
      {
        title: this.context.translate("_ASSIGN_ZONE_"),
        dataIndex: "name",
        key: "zoneId",
      },
      {
        title: this.context.translate("_REMOVE_"),
        dataIndex: "action",
        render: (text, record, index) => {
          return (
            <>
              <Space>
                <Tooltip
                  title={this.context.translate("_REMOVE_")}
                  color={config.tooltipColorDelete}
                >
                  <Link
                    onClick={async () => {
                      await this.onDeleteRow(index, Number(record.zoneId));
                    }}
                  >
                    {" "}
                    <DeleteFilled style={{ color: config.deleteColor }} />
                  </Link>
                </Tooltip>
              </Space>
            </>
          );
        },
      },
    ];
    this.setState({ loadData: 1 });
  }

  onDeleteRow = async (index, zoneId) => {
    const filterData = this.state.assignZoneArray.filter(
      (val, indexx) => indexx !== index
    );
    const selectedAssignedGeoId = filterData.map((item) => item.zoneId);
    const selectedSearchGeoId = this.state.selectedSearchZoneId.filter(
      (id) => id !== zoneId
    );

    await this.setState({
      assignZoneArray: filterData,
      selectedSearchZoneId: selectedSearchGeoId,
      assignedZoneId: selectedAssignedGeoId,
    });
  };

  // searchInput = async (value) => {
  //   let inputData = value.toLowerCase();
  //   console.log(this.assignZoneStore?.geoDataArr)
  //   const data = await this.assignZoneStore?.geoDataArr?.filter((zone) => {
  //     return zone.name.toLowerCase().includes(inputData);
  //   });

  //   await this.setState({ searchGeofenceData: data });
  // };

  async searchInput(searchText) {
    // Call your search API or logic and get filtered searchGeofenceData
    await this.assignZoneStore.getGeofenceData(this.props.companyId, searchText);
  
    const searchData = this.assignZoneStore?.geoDataArr || [];
  
    // Now update the state
    await this.setState({
      searchGeofenceData: searchData,
    });
  
    
    const assignedZones = this.state.assignZoneArray || [];
  
    const selectedRowKeys = searchData
      .filter(item => assignedZones.find(zone => zone.zoneId === item.zoneId))
      .map(item => item.zoneId);
  
    await this.setState({
      assignedZoneId: selectedRowKeys,
      selectedSearchZoneId: selectedRowKeys,
    });
  }
  

  onAssignZoneToFare = async (val) => {
    const zoneData = this.state.assignZoneArray.map((val) => {
      return val.zoneId;
    });
    const data = {
      tokenId: "",
      companyId: this.props.companyId,
      vehicleTypeId: this.props.assignData.vehicleTypeId,
      fromDate: this.props.assignData.fromDate,
      toDate: this.props.assignData.toDate,
      parameterId: this.props.parameterId,
      isadmin: "-1",
      zoneId: zoneData,
      all: this.state.all,
    };

    const response = await this.assignZoneStore.addZoneData(data);

    if (response.success === "S") {
      message.success(response.message);
      this.props.closeModal();
    }
  };

  handleRemoveAll = () => {
    this.setState({ selectedSearchZoneId: [], assignedZoneId: [], assignZoneArray: [] });
  };

  handleRemoveSelected = () => {
    this.setState({ assignZoneArray: [] })
  }
  closeModal = () => {
    this.props.closeModal();
  }
  render() {
    return (
      <div style={{ padding: 0, height: "100%" }}>
        <div style={{ paddingBottom: "10px", height: "100%" }}>
          <Form
            // style={{ maxWidth: "100%" }}
            ref={this.formRef}
            layout="vertical"
            onFinish={this.onAssignZoneToFare}
            {...this.layout}
            name="nest-message"
            className="formClass"
          >
            <Row className="overflowFormInputs">
              <Col span={24} className="formColumnClass">
                <Form.Item name="all" label="">
                  <Checkbox
                    checked={this.state.all}
                    onChange={async (e) => {
                      await this.setState({
                        all: e.target.checked,
                      });
                    }}
                  >
                    Assign All Geofence
                  </Checkbox>
                </Form.Item>

                <Form.Item
                  name=""
                  label={this.context.translate("_SEARCH_GEOFENCE_")}
                >
                  <Input
                    onChange={async (e) => {
                      await this.searchInput(e.target.value);
                    }}
                  />
                </Form.Item>

                <br />

                <Row>
                  <Col span={11}>
                    <Table
                      bordered
                      columns={this.columns}
                      dataSource={this.state.searchGeofenceData}
                      pagination={false}
                      rowKey={"zoneId"}
                      scroll={{ x: 100, y: 350 }}
                      rowSelection={{
                        selectedRowKeys: this.state.assignedZoneId,   // ✅ bind selected keys
                        onChange: async (selectedRowKeys, selectedRows) => {
                          const previousZones = this.state.assignZoneArray || [];
                        
                          const allZones = [...previousZones];
                        
                          selectedRows.forEach(row => {
                            if (!allZones.find(existing => existing.zoneId === row.zoneId)) {
                              allZones.push(row);  // only add if not already present
                            }
                          });
                        
                          await this.setState({
                            assignedZoneId: allZones.map(zone => zone.zoneId),  // selected IDs from assignZoneArray
                            assignZoneArray: allZones,   // update assigned zones
                            selectedSearchZoneId: allZones.map(zone => zone.zoneId),
                          });
                        }
                        ,
                      }}
                    />
                  </Col>

                  <Col span={2}></Col>

                  <Col span={11}>
                    <Table
                      bordered
                      columns={this.assignedColumns}
                      dataSource={this.state.assignZoneArray}    // ✅ correct data for 2nd table
                      pagination={false}
                      rowKey={"zoneId"}
                      scroll={{ x: 100, y: 350 }}
                      rowSelection={{
                        selectedRowKeys: this.state.assignedZoneId,  // ✅ same selection linked
                        onChange: async (selectedRowKeys) => {
                          await this.setState({
                            assignedZoneId: selectedRowKeys,
                            selectedSearchZoneId: selectedRowKeys,
                          });
                        },
                      }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>


            <div className="formFooter">
              <Button
                className="formsCancelButton"
                onClick={() => {
                  this.closeModal();
                  this.setState({ show: false });
                }}
              >
                {this.context.translate(
                  "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                )}
              </Button>
              {/* <Button
                type="primary"
                className="formSaveButton"
                onClick={this.handleRemoveSelected}
              >
                {this.context.translate("_REMOVE_")}
              </Button> */}
              <Button
                className="formsSaveButton"
                onClick={this.handleRemoveSelected}
              >
                {this.context.translate("_REMOVE_")}
              </Button>
              {/* <Button
                type="primary"
                // style={{ width: "113px" }}
                className="formSaveButton"
                onClick={this.handleRemoveAll}
              >
                {this.context.translate("_REMOVE_ALL_")}
              </Button> */}
              <Button
                className="formsSaveButton"
                onClick={this.handleRemoveAll}
              >
                {this.context.translate("_REMOVE_ALL_")}
              </Button>

              <Button
                htmlType="submit"
                loading={this.state.loading}
                className="formsSaveButton"
              >
                {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
              </Button>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

AssignZoneToFair.contextType = StoreContext;
export default observer(withRouter(AssignZoneToFair));
